import { Component, inject, Input, OnInit, signal } from '@angular/core';
import { FormControl } from '@angular/forms';
import { BaseModalComponent } from '@card-software/library';
import { Greige } from '@app/models/greige/greige';
import { Roll } from '@app/models/knitting/roll';
import { EnumService } from '@app/services/enum.service';

@Component({
  selector: 'app-roll-detail-modal',
  templateUrl: './roll-detail-modal.component.html',
  styleUrl: './roll-detail-modal.component.scss',
})
export class RollDetailModalComponent extends BaseModalComponent<Roll | null> implements OnInit {
  @Input() roll: Roll | null = null;
  /** The roll payload carries no greige, so the caller passes the one it resolved from the fabric. */
  @Input() greige: Greige | null = null;

  private readonly enumService = inject(EnumService);

  public timeStamp = new FormControl<Date | null>(null);
  public statusName = signal('');

  ngOnInit(): void {
    if (this.roll) {
      this.setInitialValues();
    }
  }
  onClose() {
    this.close({ action: 'close', data: null });
  }

  setInitialValues() {
    const dateValue = this.roll?.createdDate ? new Date(this.roll.createdDate) : new Date();

    this.timeStamp.setValue(dateValue);

    const status = this.roll!.status;
    const statusValues = this.enumService.getEnum('RollStatus', 'productionEnums')?.values ?? {};
    this.statusName.set(statusValues[status] ?? String(status ?? ''));
  }

  parseDate(date: Date, asString = false): Date | string {
    if (asString) {
      return date.toISOString();
    }

    return date;
  }
}
